import moment from 'moment';
import 'moment/locale/de';

/**
 * Render a "last seen" timestamp for a device card.
 *
 * - `liveMessage` is the moment() captured on the most recent SSE frame.
 *   The backend's MQTT cache replays retained messages to every new
 *   subscriber, which means this flips to "now" even for devices that
 *   actually went offline weeks ago. We therefore only trust it when the
 *   device is currently reporting online; otherwise the database value
 *   is the authoritative "last seen".
 * - `dbLastConnection` is the backend's `last_connection` ISO string. Go
 *   serializes uninitialised time.Time fields as "0001-01-01T00:00:00Z",
 *   which is technically a valid moment but obviously not a real
 *   connection — guard with a sane lower-bound year.
 * - `online` is the live online flag. When false we treat liveMessage as
 *   stale retained noise and only render the DB date.
 *
 * If the chosen timestamp is older than 12 hours we switch from a relative
 * "fromNow" to an absolute date+time — "vor 3 Wochen" is less actionable
 * than "12.05.2026 09:14" when the operator wants to know whether to
 * follow up.
 */
const RELATIVE_WINDOW_HOURS = 12;

const formatLastSeen = (liveMessage, dbLastConnection, online = false) => {
  const candidate = online ? (liveMessage || dbLastConnection) : dbLastConnection;
  if (!candidate) return 'Noch nicht verbunden';

  const m = moment(candidate);
  if (!m.isValid() || m.year() < 2000) return 'Noch nicht verbunden';

  if (moment().diff(m, 'hours') > RELATIVE_WINDOW_HOURS) {
    return m.locale('de').format('DD.MM.YYYY HH:mm');
  }
  return m.locale('de').fromNow();
};

export default formatLastSeen;
